import { __generator, __values } from "tslib";
import { delay } from 'redux-saga';
import { put, call, select, takeEvery } from 'redux-saga/effects';
import { isNil } from 'lodash-es';
import md5 from 'md5';
import * as actionTypes from '../constants/actionTypes';
import * as actionCreators from '../actionCreators';
import * as api from '../services/api';
import { connect as pusherConnect } from '../services/pusher';
import * as pusherConstants from '../constants/pusher';
import { getScreenAssets, getElementAssets, getElementAssetsOfType, } from '../utils/handoff/assets';
import { getArtboardTitle, getElements } from '../selectors/handoff';
export default function downloadAssetType() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actionTypes.DOWNLOAD_ASSETS, function (_a) {
                    var zip, requestID, actionParams, _b, unsubscribe, zipCreatedPromise, response, zipUrl, message;
                    var screenID = _a.screenID, elementID = _a.elementID, assetType = _a.assetType;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [5 /*yield**/, __values(getZipRequestPayload(elementID, assetType))];
                            case 1:
                                zip = _c.sent();
                                requestID = md5(JSON.stringify(zip));
                                zip.channel = requestID;
                                actionParams = {
                                    screenID: screenID,
                                    elementID: elementID,
                                    assetType: assetType,
                                    requestID: requestID,
                                };
                                return [4 /*yield*/, put(actionCreators.downloadAssetsStart(actionParams))];
                            case 2:
                                _c.sent();
                                return [5 /*yield**/, __values(connectToAssetChannel(requestID))];
                            case 3:
                                _b = _c.sent(), unsubscribe = _b.unsubscribe, zipCreatedPromise = _b.zipCreatedPromise;
                                return [4 /*yield*/, call(api.getZip, zip)];
                            case 4:
                                response = _c.sent();
                                if (!response.zip_url) return [3 /*break*/, 5];
                                // download is available immediately
                                zipUrl = response.zip_url;
                                unsubscribe();
                                return [3 /*break*/, 7];
                            case 5: return [4 /*yield*/, zipCreatedPromise];
                            case 6:
                                message = _c.sent();
                                zipUrl = message.content.zip_url;
                                _c.label = 7;
                            case 7: return [4 /*yield*/, put(actionCreators.assetsZipCreated(zipUrl, actionParams))];
                            case 8:
                                _c.sent();
                                return [4 /*yield*/, call(delay, 3000)];
                            case 9:
                                _c.sent();
                                return [4 /*yield*/, put(actionCreators.assetsZipDownloaded(actionParams))];
                            case 10:
                                _c.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getZipRequestPayload(elementID, assetType) {
    var element, elements, screenName;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(function (state) {
                    return state.handoff.flatCanvas.find(function (e) { return e.id === elementID; });
                })];
            case 1:
                element = _a.sent();
                if (!isNil(elementID)) return [3 /*break*/, 4];
                return [4 /*yield*/, select(getElements)];
            case 2:
                elements = _a.sent();
                return [4 /*yield*/, select(getArtboardTitle)];
            case 3:
                screenName = _a.sent();
                return [2 /*return*/, getScreenAssets(screenName, elements)];
            case 4:
                if (!assetType) {
                    return [2 /*return*/, getElementAssets(element)];
                }
                return [2 /*return*/, getElementAssetsOfType(element, assetType)];
        }
    });
}
function connectToAssetChannel(requestID) {
    var prefix, pusherChannel, _a, channel, unsubscribe, zipCreatedPromise;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return state.project.config.pusherAnonChannelPrefix; })];
            case 1:
                prefix = _b.sent();
                pusherChannel = prefix + "-" + requestID;
                _a = pusherConnect(pusherChannel), channel = _a.channel, unsubscribe = _a.unsubscribe;
                zipCreatedPromise = new Promise(function (resolve) {
                    channel.bind(pusherConstants.EVENT_ASSESTS_ZIP_CREATED, function (response) {
                        unsubscribe();
                        resolve(response);
                    });
                });
                return [2 /*return*/, { unsubscribe: unsubscribe, zipCreatedPromise: zipCreatedPromise }];
        }
    });
}
